import * as React from "react";
import styled from "styled-components";
import { usePopperTooltip } from "react-popper-tooltip";
import "react-popper-tooltip/dist/styles.css";

import MoreVertIcon from "@mui/icons-material/MoreVert";

const Container = styled.div`
    background-color: #fff;
    max-width: 170px;
    font-size: 14px;
    border: 1px solid #9a9c9f;
    width: 170px;
    position: relative;
    left: -33%;
    text-transform: capitalize;
`;

export const ActionsList = styled.li`
    padding: 7px;
    cursor: default;
    &:hover {
        color: #0061a6;
        background-color: rgba(0, 119, 204, 0.2);
        cursor: pointer;
        border-radius: 4px;
    }
    &.disable {
        color: #abb4c4;
        cursor: not-allowed;
        background-color: transparent;
        text-decoration: none;
    }
`;
export default function DropDown({ options }) {
    const [open, setOpen] = React.useState(false);

    const { getTooltipProps, setTooltipRef, setTriggerRef, visible } = usePopperTooltip({
        trigger: "click",
        interactive: true,
        placement: "bottom-start",
        visible: open,
        onVisibleChange: setOpen,
    });

    const handleTooltipClose = () => {
        setOpen(false);
    };

    return (
        <>
            <div
                style={{ cursor: "pointer" }}
                ref={setTriggerRef}
            >
                <MoreVertIcon />
            </div>
            {visible && (
                <Container
                    ref={setTooltipRef}
                    {...getTooltipProps({ className: "tooltip-container" })}
                >
                    <>
                        <ul>
                            {options &&
                                options.map((item) => (
                                    <ActionsList
                                        className={item.disable ? "disable" : ""}
                                        onClick={() => {
                                            if (!item.disable) {
                                                item.eventHandler();
                                                handleTooltipClose();
                                            } else return;
                                        }}
                                    >
                                        {item.name}
                                    </ActionsList>
                                ))}
                        </ul>
                    </>
                </Container>
            )}
        </>
    );
}
